export default "/images/vendor/flag-icons/flags/4x3/is.svg?3c4b4181458260fed9fc1d00c2c7c3a0";